import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function FacebookPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  return null;
}
